<template>
  <section class="comparar">
    <div class="itens">
      <div class="linha titulo fixo">
        <div class="item">
          <h2>Planos Level</h2>
        </div>
        <div class="item" v-for="plano in planos" :key="plano.nome">
          <img :src="`https://central-statics.nyc3.digitaloceanspaces.com/global/planos/${plano.icone}.png`" />
          <p>{{ plano.nome }}</p>
        </div>
      </div>

      <div class="linha titulo">
        <div class="item">
          <h2>Planos Level</h2>
        </div>
        <div class="item" v-for="plano in planos" :key="plano.nome">
          <img :src="`https://central-statics.nyc3.digitaloceanspaces.com/global/planos/${plano.icone}.png`" />
          <p>{{ plano.nome }}</p>
        </div>
      </div>

      <div v-for="linha in linhasPadrao" :key="linha.titulo" class="linha padrao">
        <div class="item">
          <h3>{{ linha.titulo }}</h3>
        </div>
        <div class="item" v-for="(conteudo, index) in linha.conteudos" :key="index" :class="{ desativado: conteudo.icone === 'x' }">
          <Svgs :nome="conteudo.icone" />
          <p>{{ conteudo.texto }}</p>
        </div>
      </div>

      <div class="categoria">
        <Svgs nome="download" />
        <h2>Publicação</h2>
      </div>

      <div v-for="linha in linhasPublicacao" :key="linha.titulo" class="linha padrao">
        <div class="item">
          <h3>{{ linha.titulo }}</h3>
        </div>
        <div class="item" v-for="(conteudo, index) in linha.conteudos" :key="index" :class="{ desativado: conteudo.icone === 'x' }">
          <Svgs :nome="conteudo.icone" />
          <p>{{ conteudo.texto }}</p>
        </div>
      </div>

      <div class="categoria">
        <Svgs nome="template" />
        <h2>Layouts para sua área</h2>
      </div>

      <div v-for="linha in linhasConstrutor" :key="linha.titulo" class="linha padrao">
        <div class="item">
          <img v-if="linha.iconeMaior" :src="linha.iconeMaior" />
          <h3>{{ linha.titulo }}</h3>
        </div>
        <div class="item" v-for="(conteudo, index) in linha.conteudos" :key="index" :class="{ desativado: conteudo.icone === 'x' }">
          <Svgs :nome="conteudo.icone" />
          <p>{{ conteudo.texto }}</p>
        </div>
      </div>

      <div class="categoria">
        <Svgs nome="dinheiro" />
        <h2>Gateways de pagamento</h2>
      </div>

      <div v-for="linha in linhasGateways" :key="linha.titulo" class="linha padrao">
        <div class="item">
          <h3>{{ linha.titulo }}</h3>
        </div>
        <div class="item" v-for="(conteudo, index) in linha.conteudos" :key="index" :class="{ desativado: conteudo.icone === 'x' }">
          <Svgs :nome="conteudo.icone" />
          <p>{{ conteudo.texto }}</p>
        </div>
      </div>

      <div class="categoria">
        <Svgs nome="integracao" />
        <h2>Integrações</h2>
      </div>

      <div v-for="linha in linhasIntegracoes" :key="linha.titulo" class="linha padrao">
        <div class="item">
          <h3>{{ linha.titulo }}</h3>
        </div>
        <div class="item" v-for="(conteudo, index) in linha.conteudos" :key="index" :class="{ desativado: conteudo.icone === 'x' }">
          <Svgs :nome="conteudo.icone" />
          <p>{{ conteudo.texto }}</p>
        </div>
      </div>

      <div class="categoria">
        <Svgs nome="usuario" />
        <h2>Suporte</h2>
      </div>

      <div v-for="linha in linhasSuporte" :key="linha.titulo" class="linha padrao">
        <div class="item">
          <h3>{{ linha.titulo }}</h3>
        </div>
        <div class="item" v-for="(conteudo, index) in linha.conteudos" :key="index" :class="{ desativado: conteudo.icone === 'x' }">
          <Svgs :nome="conteudo.icone" />
          <p>{{ conteudo.texto }}</p>
        </div>
      </div>

      <div class="categoria">
        <Svgs nome="estrela" />
        <h2>Bônus</h2>
      </div>

      <div v-for="linha in linhasBonus" :key="linha.titulo" class="linha padrao">
        <div class="item">
          <h3>{{ linha.titulo }}</h3>
        </div>
        <div class="item" v-for="(conteudo, index) in linha.conteudos" :key="index" :class="{ desativado: conteudo.icone === 'x' }">
          <Svgs :nome="conteudo.icone" />
          <p>{{ conteudo.texto }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import Svgs from '@svgs'

const planos = [
  {
    nome: 'Free',
    icone: 'free'
  },
  {
    nome: 'Silver',
    icone: 'silver'
  },
  {
    nome: 'Gold',
    icone: 'gold'
  },
  {
    nome: 'Diamond',
    icone: 'diamond'
  }
]

const linhasPadrao = [
  {
    titulo: 'Áreas do plano',
    conteudos: [
      { icone: 'check', texto: '1 área de membros' },
      { icone: 'check', texto: '1 área de membros' },
      { icone: 'check', texto: '3 áreas de membros' },
      { icone: 'check', texto: '10 áreas de membros' }
    ]
  },
  {
    titulo: 'Limite de alunos',
    conteudos: [
      { icone: 'check', texto: '50 alunos' },
      { icone: 'check', texto: '4.000 alunos' },
      { icone: 'check', texto: '15.000 alunos' },
      { icone: 'check', texto: '100.000 alunos' }
    ]
  },
  {
    titulo: 'Domínios externos',
    conteudos: [
      { icone: 'x', texto: 'Sem domínio' },
      { icone: 'check', texto: '1 domínio' },
      { icone: 'check', texto: '3 domínios' },
      { icone: 'check', texto: '10 domínios' }
    ]
  },
  {
    titulo: 'Cadastros ilimitados',
    conteudos: [
      { icone: 'check', texto: 'Cursos, aulas e módulos' },
      { icone: 'check', texto: 'Cursos, aulas e módulos' },
      { icone: 'check', texto: 'Cursos, aulas e módulos' },
      { icone: 'check', texto: 'Cursos, aulas e módulos' }
    ]
  }
]
const linhasPublicacao = [
  {
    titulo: 'Backup das Áreas',
    conteudos: [
      { icone: 'check', texto: 'Diário' },
      { icone: 'check', texto: 'Diário' },
      { icone: 'check', texto: 'Diário' },
      { icone: 'check', texto: 'Diário' }
    ]
  },
  {
    titulo: 'Publicação da Área',
    conteudos: [
      { icone: 'x', texto: 'Sem publicação' },
      { icone: 'check', texto: 'Em segundos' },
      { icone: 'check', texto: 'Em segundos' },
      { icone: 'check', texto: 'Em segundos' }
    ]
  },
  {
    titulo: 'Certificado SSL',
    conteudos: [
      { icone: 'check', texto: 'Em todas Áreas' },
      { icone: 'check', texto: 'Em todas Áreas' },
      { icone: 'check', texto: 'Em todas Áreas' },
      { icone: 'check', texto: 'Em todas Áreas' }
    ]
  },
  {
    titulo: 'Servidor Potente',
    conteudos: [
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' }
    ]
  },
  {
    titulo: 'Vídeos',
    conteudos: [
      { icone: 'check', texto: 'Youtube, Vimeo, Panda' },
      { icone: 'check', texto: 'Youtube, Vimeo, Panda' },
      { icone: 'check', texto: 'Youtube, Vimeo, Panda' },
      { icone: 'check', texto: 'Youtube, Vimeo, Panda' }
    ]
  }
]
const linhasConstrutor = [
  {
    titulo: 'Estilo Coluna',
    conteudos: [
      { icone: 'check', texto: 'Liberado' },
      { icone: 'check', texto: 'Liberado' },
      { icone: 'check', texto: 'Liberado' },
      { icone: 'check', texto: 'Liberado' }
    ]
  },
  {
    titulo: 'Estilo Quadro',
    conteudos: [
      { icone: 'check', texto: 'Liberado' },
      { icone: 'check', texto: 'Liberado' },
      { icone: 'check', texto: 'Liberado' },
      { icone: 'check', texto: 'Liberado' }
    ]
  },
  {
    titulo: 'Estilo Trilhas',
    conteudos: [
      { icone: 'check', texto: 'Liberado' },
      { icone: 'check', texto: 'Liberado' },
      { icone: 'check', texto: 'Liberado' },
      { icone: 'check', texto: 'Liberado' }
    ]
  }
]
const linhasGateways = [
  {
    titulo: 'Hotmart',
    conteudos: [
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' }
    ]
  },
  {
    titulo: 'Ticto',
    conteudos: [
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' }
    ]
  },
  {
    titulo: 'Kiwify',
    conteudos: [
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' }
    ]
  },
  {
    titulo: 'Outras plataformas',
    conteudos: [
      { icone: 'x', texto: 'Sem acesso' },
      { icone: 'x', texto: 'Sem acesso' },
      { icone: 'check', texto: 'Solicitar' },
      { icone: 'check', texto: 'Solicitar' }
    ]
  }
]
const linhasIntegracoes = [
  {
    titulo: 'Pixel do Facebook',
    conteudos: [
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' }
    ]
  },
  {
    titulo: 'Google Tag Manager',
    conteudos: [
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' },
      { icone: 'check', texto: 'Ativo' }
    ]
  }
]
const linhasSuporte = [
  {
    titulo: 'Chat',
    conteudos: [
      { icone: 'check', texto: 'Sex à Sex' },
      { icone: 'check', texto: '24h' },
      { icone: 'check', texto: '24h' },
      { icone: 'check', texto: '24h' }
    ]
  },
  {
    titulo: 'E-mail',
    conteudos: [
      { icone: 'check', texto: 'Seg à Sex' },
      { icone: 'check', texto: ' Seg à Sex' },
      { icone: 'check', texto: ' Seg à Sex' },
      { icone: 'check', texto: ' Seg à Sex' }
    ]
  },
  {
    titulo: 'Tutoriais',
    conteudos: [
      { icone: 'check', texto: 'Em vídeo e texto' },
      { icone: 'check', texto: 'Em vídeo e texto' },
      { icone: 'check', texto: 'Em vídeo e texto' },
      { icone: 'check', texto: 'Em vídeo e texto' }
    ]
  }
]
const linhasBonus = [
  {
    titulo: 'Criador Landing Pages',
    conteudos: [
      { icone: 'x', texto: 'Sem acesso' },
      { icone: 'check', texto: '30 dias grátis' },
      { icone: 'check', texto: '30 dias grátis' },
      { icone: 'check', texto: '30 dias grátis' }
    ]
  },
  {
    titulo: 'Onboarding Especialista',
    conteudos: [
      { icone: 'x', texto: 'Sem acesso' },
      { icone: 'x', texto: 'Sem acesso' },
      { icone: 'check', texto: 'Liberado' },
      { icone: 'check', texto: 'Liberado' }
    ]
  }
]
</script>

<style scoped>
section.comparar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 40px 0 0 0;
}
.itens {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.categoria {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin: 20px 0 15px 25px;
}
.categoria h2 {
  font-family: var(--medium);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.categoria svg {
  width: 12px;
  min-width: 12px;
  fill: var(--cor-branco);
  margin: 0 10px 0 0;
}
.item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 18.75%;
}
.item.desativado {
  opacity: 0.4;
}
.item:nth-child(1) {
  width: 25%;
}
.linha {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: var(--cor-escuro-2);
  height: 50px;
  padding: 0 15px;
  border-radius: 8px;
  margin: 0 0 5px 0;
}
.linha.titulo {
  height: auto;
  margin: 0 0 15px 0;
  background-color: var(--cor-escuro-1);
}
.linha.titulo.fixo {
  position: fixed;
  height: 40px;
  top: 0;
  width: calc(100% - 260px);
  padding: 0 40px 0 40px;
  border-bottom: 2px solid var(--cor-escuro-2);
  transition: all 0.3s;
  z-index: 3;
}
section.planos.fixo section.comparar .linha.titulo.fixo {
  top: 80px;
}
.linha.titulo .item h2 {
  font-family: var(--medium);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.linha.titulo .item img {
  width: 12px;
  margin: 0 5px 0 0;
}
.linha.titulo .item p {
  font-family: var(--medium);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.linha.padrao .item {
  align-items: center;
}
.linha.padrao .item img {
  width: 100%;
  max-width: 20px;
  margin: 0 5px 0 0;
}
.linha.padrao .item svg {
  width: 10px;
  min-width: 10px;
  max-height: 10px;
  fill: var(--cor-escuro-6);
  margin: 0 10px 0 0;
}
.linha.padrao .item p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
}
.linha.padrao .item h3 {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
}
@media screen and (max-width: 1024px) {
  section.comparar {
    padding: 0;
  }
  .itens {
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    overflow-x: scroll;
    scrollbar-width: none;
    padding: 0 20px;
  }
  .itens::-webkit-scrollbar {
    display: none;
  }
  .categoria {
    margin: 20px 0 15px 15px;
  }
  .linha {
    height: 45px;
    min-width: 700px;
  }
  .linha.titulo.fixo {
    display: none;
  }
  .linha.titulo .item h2 {
    font-size: var(--f1);
  }
  .linha.titulo .item p {
    font-size: var(--f1);
  }
  .linha.padrao .item {
    padding: 0;
  }
  .linha.padrao .item svg {
    width: 10px;
    min-width: 10px;
    max-height: 10px;
    margin: 0 8px 0 0;
  }
  .linha.padrao .item p {
    font-size: var(--f1);
  }
  .linha.padrao .item h3 {
    font-size: var(--f1);
  }
}
</style>
